import { Link } from "react-router-dom";
import { useLanguage } from './LanguageProvider';
import  LanguageSwitch from './LanguageSwitch'

function AllHeads() {

    const { language } = useLanguage();

    return (
        <div className="d-flex align-items-center justify-content-center">
            <Link className="text-decoration-none menu-indent menu-text " to={"/buy"}>{language === 'en' ? 'Buy' : 'Купити'}</Link>
            <Link className="text-decoration-none menu-text " to={"/rent"}>{language === 'en' ? 'Rent' : 'Орендувати'}</Link>
            <Link className="text-decoration-none menu-indent menu-text " to={"/sell"}>{language === 'en' ? 'For owners' : 'Власникам'}</Link>
            {/* <Link className="text-decoration-none card-address menu-indent" to={"/contacts"}>{language === 'en' ? 'About Us' : 'Про нас'}</Link> */}
            <LanguageSwitch />

        </div>
    );

}

export default AllHeads;
